import { z } from "zod";

export const giftSchema = z.object({
  id: z.string().optional(),
  name: z.string(),
  icon: z.string().optional(),
  type: z.string().optional(),
  probability: z.number().optional(),
  limit: z.number().optional(),
  initial_limit: z.number().optional(),
}).superRefine((gift, ctx) => {
  if (gift.type === "LOSS") return;

  if (!gift.name?.trim()) {
    ctx.addIssue({ code: "custom", message: "errors.gifts.empty_fields", path: ["name"] });
  }
  if (!gift.type) {
    ctx.addIssue({ code: "custom", message: "errors.gifts.empty_fields", path: ["type"] });
  }
  // without an icon the game requests /cdn/icons/undefined.svg, which the CDN answers 200 with index.html:
  // blank wheel slice / solid slot symbol, no error anywhere. Same trap as an unsupported logo, see utils/logo.ts
  if (!gift.icon?.trim()) {
    ctx.addIssue({ code: "custom", message: "errors.gifts.missing_icon", path: ["icon"] });
  }
  if (String(gift.id ?? "").startsWith("new-")) {
    if (typeof gift.limit !== "number" || isNaN(gift.limit)) {
      ctx.addIssue({ code: "custom", message: "errors.gifts.empty_fields", path: ["limit"] });
    } else if (gift.limit !== -1) {
      if (gift.initial_limit == null || isNaN(gift.initial_limit) || gift.initial_limit < 0) {
        ctx.addIssue({ code: "custom", message: "errors.gifts.empty_fields", path: ["initial_limit"] });
      }
    }
  }
});

export type Gift = z.infer<typeof giftSchema>;
